import React from 'react';
import styled, { keyframes } from 'styled-components';

const zoomInOut = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(0.8);
    opacity: 0.8;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const PreloaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: ${props => props.isExiting ? fadeOut : 'none'} 0.3s ease-in-out;
  transition: opacity 0.3s ease-in-out;
`;

const Logo = styled.img`
  width: 200px;
  height: auto;
  animation: ${zoomInOut} 2s ease-in-out infinite;

  @media (max-width: 768px) {
    width: 150px;
  }
`;

const Preloader = ({ isVisible, isExiting }) => {
  if (!isVisible) return null;

  return (
    <PreloaderContainer isExiting={isExiting}>
      <Logo src="/logo.jpeg" alt="RPL Support" />
    </PreloaderContainer>
  );
};

export default Preloader;